import Phaser from 'phaser'
import { sharedInstance as events, LOGO_OVERLAY_VISIBILITY_EVENT } from './EventCenter'

const OVERLAY_LOGO_KEY = 'overlay-logo'
const OVERLAY_LOGO_PATH = 'assets/logo.png'
const LOGO_INITIAL_WIDTH_PX = 535
const LOGO_REDUCTION_FACTOR = 0.3
const LOGO_TOP_Y_FACTOR = 0.05

export default class LogoOverlay extends Phaser.Scene
{
	private logo?: Phaser.GameObjects.Image
	private resizeHandler?: (gameSize: Phaser.Structs.Size) => void

	constructor()
	{
		super('logo-overlay')
	}

	preload()
	{
		if (!this.textures.exists(OVERLAY_LOGO_KEY))
		{
			this.load.image(OVERLAY_LOGO_KEY, OVERLAY_LOGO_PATH)
		}
	}

	create()
	{
		this.logo = this.add.image(0, 0, OVERLAY_LOGO_KEY)
		this.logo.setAlpha(1)

		this.layoutLogo()
		events.on(LOGO_OVERLAY_VISIBILITY_EVENT, this.handleVisibilityChange, this)

		this.resizeHandler = () => {
			this.layoutLogo()
		}
		this.scale.on(Phaser.Scale.Events.RESIZE, this.resizeHandler)

		this.events.once(Phaser.Scenes.Events.SHUTDOWN, () => {
			events.off(LOGO_OVERLAY_VISIBILITY_EVENT, this.handleVisibilityChange, this)
			if (this.resizeHandler)
			{
				this.scale.off(Phaser.Scale.Events.RESIZE, this.resizeHandler)
				this.resizeHandler = undefined
			}
		})
	}

	private handleVisibilityChange(isVisible: boolean)
	{
		if (!this.logo)
		{
			return
		}

		this.tweens.killTweensOf(this.logo)
		this.tweens.add({
			targets: this.logo,
			alpha: isVisible ? 1 : 0,
			duration: 220,
			ease: 'Sine.easeInOut'
		})
	}

	private layoutLogo()
	{
		if (!this.logo)
		{
			return
		}

		const screenWidth = this.scale.width
		const screenHeight = this.scale.height
		const source = this.textures.get(OVERLAY_LOGO_KEY).getSourceImage() as { width: number, height: number }
		const reducedWidth = LOGO_INITIAL_WIDTH_PX * LOGO_REDUCTION_FACTOR
		const desiredWidth = Math.min(reducedWidth, screenWidth * 0.4)
		const scale = desiredWidth / source.width

		this.logo.setScale(scale)
		this.logo.setPosition(screenWidth * 0.5, screenHeight * LOGO_TOP_Y_FACTOR)
	}
}
